import React, { ReactElement, useEffect } from 'react'
import Divider from '../Divider'
import PortfolioOverview from './PortfolioOverview'

const PortfolioPanel = (): ReactElement => {
    useEffect(() => {
        window.location.hash = `#portfolio`
    }, [])

    return (
        <div className="panel">
            <Divider />
            <PortfolioOverview />
        </div>
    )
}

export default PortfolioPanel
